// JavaScript Document





function setPins(){
  setTimeout(function(){
    imageHeight = $('.vi-uf-pinBoxBgImg').find('img').height();
    $('.vi-uf-pinBoxBgImg').css({'height':imageHeight});

    $('.vi-uf-pinBoxBgImg').find('.vi-uf-pinBoxInner').each(function(element){
      frameWidthPerc = $('.vi-uf-pinBoxBgImg').innerWidth()/100;
      frameHeightPerc = $('.vi-uf-pinBoxBgImg').innerHeight()/100;
      itemPosX = parseFloat($(this).attr('data-tag-posx') * frameWidthPerc);
      itemPosY = parseFloat($(this).attr('data-tag-posy') * frameHeightPerc);
      $(this).css({"margin-top":itemPosY, "margin-left":itemPosX});
    });
  }, 500);
}

function togglePinInfo(_elem) {

    if ($(_elem).hasClass('vi-uf-pinBoxInnerContent')){
        $(_elem).toggleClass('hide');
    } else {
        $(_elem).find('.vi-uf-pinBoxInnerContent').toggleClass('hide');
    }

}
